<seb-modal [bClose]="bbClose" [confirmationTitle]="labelTitleModal" #confirmationModal>
    <button class="btn btn-primary" (click)="onConfirm(true)" footer>
        {{labelBtnConfirmation}}
    </button>
</seb-modal>